export default __webpack_public_path__ + "static/media/img_blog03.2935676c.jpg";